import { render, staticRenderFns } from "./VendorSummary.vue?vue&type=template&id=8347798e&scoped=true&"
import script from "./VendorSummary.vue?vue&type=script&lang=js&"
export * from "./VendorSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8347798e",
  null
  
)

export default component.exports